/** Cap so a buggy or huge Retry-After cannot stall asset sync for hours. */
export const RETRY_AFTER_MAX_MS = 120_000
/** Used when the header is missing/invalid (matches API PLAYER_ASSET_DOWNLOAD window). */
export const RETRY_AFTER_DEFAULT_MS = 60_000
export const RETRY_AFTER_MIN_MS = 1_000

/**
 * Parse RFC 7231 `Retry-After` (delta-seconds or HTTP-date) to a clamped delay in ms.
 */
export function parseRetryAfterHeaderMs(
  header: string | null | undefined,
  nowMs: number = Date.now(),
  options?: { defaultMs?: number, maxMs?: number, minMs?: number }
): number {
  const defaultMs = options?.defaultMs ?? RETRY_AFTER_DEFAULT_MS
  const maxMs = options?.maxMs ?? RETRY_AFTER_MAX_MS
  const minMs = options?.minMs ?? RETRY_AFTER_MIN_MS

  const clamp = (ms: number) => Math.min(maxMs, Math.max(minMs, Math.round(ms)))

  if (header == null || header.trim() === '') {
    return clamp(defaultMs)
  }

  const trimmed = header.trim()
  if (/^\d+$/.test(trimmed)) {
    return clamp(Number.parseInt(trimmed, 10) * 1000)
  }

  const asDate = Date.parse(trimmed)
  if (Number.isFinite(asDate)) {
    return clamp(asDate - nowMs)
  }

  return clamp(defaultMs)
}
